import { Box, IconButton, Typography } from '@material-ui/core'
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons'

import { useActivitiesCalendar } from '../../contexts/activities-calendar-context'
import { lengthOfDayInPx } from '../../utils/constants'
import { useStyles } from './styles'

export function CalendarHeader() {
  const classes = useStyles()

  const { months, weeks, days, currentYear, nextMonth, previousMonth } =
    useActivitiesCalendar()

  function handleNextMonth() {
    nextMonth()
  }

  function handlePreviousMonth() {
    previousMonth()
  }

  return (
    <div className={classes.container}>
      <div className={classes.months}>
        {months.map(
          (
            {
              monthAndYear: month,
              days,
              isCurrentMonth,
              fullMonthName,
              shortMonthName,
            },
            index,
          ) => (
            <Box
              key={`${month}-${isCurrentMonth}-${index}`}
              width={Number(days) * lengthOfDayInPx}
              data-is-selected={isCurrentMonth}
            >
              {isCurrentMonth ? (
                <>
                  <Typography component={'span'}>{fullMonthName}</Typography>
                  <Typography component={'span'}>{currentYear}</Typography>
                </>
              ) : (
                <Typography component={'span'}>{shortMonthName}</Typography>
              )}
            </Box>
          ),
        )}
      </div>

      <div className={classes.arrowButtons}>
        <IconButton
          size='small'
          onClick={handlePreviousMonth}
          aria-label='Mês anterior'
        >
          <ArrowBackIos viewBox='-5 0 24 24' />
        </IconButton>
        <IconButton
          size='small'
          onClick={handleNextMonth}
          aria-label='Próximo mês'
        >
          <ArrowForwardIos viewBox='-2 0 24 24' />
        </IconButton>
      </div>

      <div className={classes.weeks}>
        {weeks.map((week, index) => (
          <Typography key={index} component={'span'}>
            {week.start} - {week.end}
          </Typography>
        ))}
      </div>

      <div className={classes.days}>
        {days.map((dayOfWeek, index) => (
          <Typography key={index} component={'span'}>
            {dayOfWeek}
          </Typography>
        ))}
      </div>
    </div>
  )
}
